module.exports = __webpack_public_path__ + "static/media/a9.d483fb47.png";